var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 286,
    viewBox: "0 0 386 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2418_9477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0422 53.6651C45.0422 53.6651 80.1769 22.9196 123.362 37.5643C166.547 52.2021 200.219 118.81 241.941 121.009C283.663 123.207 322.459 100.512 355.396 120.274C388.333 140.036 394.192 225.678 331.238 234.463C268.29 243.249 233.156 211.775 206.071 213.238C178.987 214.701 113.114 247.638 61.143 233C9.17934 218.362 -37.667 117.347 45.0422 53.6651Z",
    fill: "#F2F6FB"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.784 58.691H129.598C128.016 58.691 126.868 57.1999 127.267 55.6738L141.289 1.80609C141.569 0.742038 142.528 0 143.62 0H293.806C295.388 0 296.536 1.49108 296.137 3.01715L282.115 56.8849C281.835 57.9489 280.876 58.691 279.784 58.691Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.205 11.522H202.463",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.18 35.6455H198.444",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.16 26.5308H220.418",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.861 19.5654H164.542",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.719 26.5308H162.4",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.771 11.522H229.392",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.898 46.9583H192.086C191.946 46.9583 191.841 46.8253 191.876 46.6922L193.122 41.911C193.15 41.82 193.234 41.75 193.332 41.75H221.144C221.284 41.75 221.389 41.883 221.354 42.016L220.108 46.7973C220.08 46.8883 219.996 46.9583 219.898 46.9583Z",
    stroke: "#84AEE5",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.326 46.9583H157.514C157.374 46.9583 157.269 46.8253 157.304 46.6922L158.55 41.911C158.578 41.82 158.662 41.75 158.76 41.75H186.572C186.712 41.75 186.817 41.883 186.782 42.016L185.536 46.7973C185.508 46.8883 185.424 46.9583 185.326 46.9583Z",
    stroke: "#84AEE5",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.775 40.0278C267.347 38.1307 261.565 36.7447 259.969 34.8476C259.15 33.8745 259.15 32.0754 259.346 30.5424C259.913 30.1783 260.389 29.8143 260.669 29.4783C261.152 28.7783 261.691 27.7982 262.23 26.7202C262.391 26.8812 262.615 27.0072 262.895 27.0002C263.651 26.9792 266.542 23.045 265.8 22.1279C265.373 21.6099 264.687 22.0579 264.176 22.5409C264.939 20.7909 265.478 19.4468 265.478 19.4468H265.45C265.52 19.2228 265.59 19.0058 265.646 18.7748C266.794 14.1755 263.994 10.4443 259.395 10.4443C254.796 10.4443 250.133 14.1755 248.985 18.7748C248.929 18.9988 248.887 19.2228 248.845 19.4468H248.817C248.817 19.4468 248.684 20.7909 248.579 22.5409C248.306 22.0579 247.844 21.6029 247.158 22.1279C245.961 23.038 246.885 26.9722 247.634 27.0002C247.914 27.0072 248.194 26.8812 248.439 26.7202C248.439 27.7982 248.495 28.7783 248.628 29.4783C248.768 29.8913 249.167 30.3463 249.692 30.7874C249.118 32.2644 248.25 33.9305 247.018 34.8476C244.47 36.7447 238.002 38.1307 235.629 40.0278C233.494 41.7359 231.589 46.7272 231.232 47.7072H269.342C269.475 46.7202 270.056 41.7359 268.775 40.0278Z",
    fill: "#8DBCF8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253.653 101.576H103.468C101.885 101.576 100.737 100.085 101.136 98.5586L115.158 44.6909C115.438 43.6268 116.397 42.8848 117.489 42.8848H267.675C269.257 42.8848 270.405 44.3758 270.006 45.9019L255.984 99.7696C255.704 100.834 254.745 101.576 253.653 101.576Z",
    stroke: "#7094D8",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.841 97.5504H100.655C99.0729 97.5504 97.9249 96.0593 98.3239 94.5332L112.346 40.6655C112.626 39.6014 113.585 38.8594 114.677 38.8594H264.862C266.444 38.8594 267.592 40.3505 267.193 41.8765L253.172 95.7443C252.892 96.8083 251.933 97.5504 250.841 97.5504Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.781 97.5503H222.958",
    stroke: "#7094D8",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.875 38.8594H190.389",
    stroke: "#7094D8",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.72 89.5128H204.95C203.396 89.5128 202.451 88.2528 202.836 86.6987L211.355 52.53C211.74 50.9759 213.315 49.7158 214.87 49.7158H248.639C250.193 49.7158 251.138 50.9759 250.753 52.53L242.234 86.6987C241.849 88.2528 240.274 89.5128 238.72 89.5128Z",
    fill: "#B7DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.141 89.6454L225.095 77.7938L220.251 75.7427C220.251 75.7427 211.221 79.0468 210.451 79.8449C209.807 80.5169 206.565 87.4263 205.529 89.6454H222.134H222.141Z",
    fill: "#023F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.865 89.6454C238.942 87.4263 239.145 80.5099 238.837 79.8449C238.466 79.0468 231.088 75.7427 231.088 75.7427L225.222 77.7938L222.268 89.6454H238.872H238.865Z",
    fill: "#023F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.202 89.6457L229.83 79.3901L219.889 79.9572L218.916 89.6457H225.202Z",
    fill: "#BEBECF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.049 73.5727L219.879 74.9448L218.458 78.3609L218.094 83.0372L221.139 81.7841L223.505 84.6333L226.669 82.0081L228.608 83.8352L231.534 77.5629L231.023 73.6917L229.798 73.1177L222.049 73.5727Z",
    fill: "#DEE0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.718 64.6056C222.718 64.6056 221.99 62.9535 220.499 64.0525C219.008 65.1516 220.751 69.3938 221.836 68.1198C222.914 66.8457 222.718 64.6056 222.718 64.6056Z",
    fill: "#FB8E74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.345 64.5145C233.345 64.5145 234.759 62.7644 235.83 63.7444C236.901 64.7245 233.387 69.2117 232.806 68.0146C232.225 66.8176 233.345 64.5145 233.345 64.5145Z",
    fill: "#FB8E74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.021 76.8839L231.547 68.7915L222.72 69.5545L220.773 77.1499C220.773 77.1499 222.314 80.7481 223.973 82.3442C223.973 82.3442 229.104 77.906 230.028 76.8769L230.021 76.8839Z",
    fill: "#FB8877"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.178 61.2524C236.849 62.2394 236.037 62.4844 235.981 63.0585C235.918 63.6325 235.554 65.1096 234.994 65.6836C234.434 66.2576 234.147 66.4186 234.147 66.4186C234.147 66.4186 226.572 68.5537 222.729 65.5996C222.729 65.5996 222.477 64.4795 222.743 63.1425C223.002 61.8194 222.358 61.5814 223.107 60.9304C223.856 60.2793 224.08 59.6983 224.094 58.9633C224.108 58.2282 224.171 57.3252 224.934 56.5831C225.704 55.8481 226.39 56.0931 227.139 55.4351C227.139 55.4351 228.245 53.58 229.701 53.37C231.157 53.16 234.238 52.3829 236.065 54.637C237.892 56.8842 237.052 58.8583 237.577 59.5583C238.102 60.2583 237.178 61.2594 237.178 61.2594V61.2524Z",
    fill: "#713336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.654 63.2123C222.654 63.2123 219.077 73.0548 225.811 73.7969C231.762 73.9369 233.869 66.6775 234.723 62.9533C235.577 59.2291 235.045 55.3369 230.285 55.4629C225.524 55.5889 223.172 61.0072 222.654 63.2123Z",
    fill: "#FBA990"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.523 59.6769C224.523 59.6769 224.964 60.468 224.558 61.259C224.152 62.057 223.039 62.358 222.878 63.4081C222.71 64.4582 222.227 66.6423 221.926 66.7403C221.625 66.8383 221.842 64.6052 221.891 63.8421C221.94 63.0791 222.507 59.9219 224.096 57.9128C225.685 55.9037 226.665 55.0567 229.493 54.6017C232.322 54.1396 234.464 55.3297 235.248 57.0588C236.032 58.7809 234.779 63.1771 234.779 63.1771C234.779 63.1771 234.968 61.091 234.268 60.601C233.568 60.1109 232.994 59.7469 233.106 59.4599C233.225 59.1729 230.865 60.2089 228.513 59.4599C226.161 58.7039 225.398 59.0469 225.013 59.2919C224.621 59.5369 224.53 59.6839 224.53 59.6839L224.523 59.6769Z",
    fill: "#713336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.865 78.4727C217.809 78.7037 214.582 86.3901 214.582 86.3901L217.417 87.8111L216.619 89.4072",
    stroke: "#022755",
    strokeWidth: 0.343017,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.824 78.4727C231.768 78.7037 231.159 86.3901 231.159 86.3901L227.609 87.8111V89.4072",
    stroke: "#022755",
    strokeWidth: 0.343017,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.718 89.5133H204.948C203.394 89.5133 202.449 88.2533 202.834 86.6992L211.353 52.5305C211.738 50.9764 213.313 49.7163 214.868 49.7163H248.637C250.191 49.7163 251.136 50.9764 250.751 52.5305L242.232 86.6992C241.847 88.2533 240.272 89.5133 238.718 89.5133Z",
    stroke: "white",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.252 51.7256H173.51",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.232 75.8418H169.49",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.209 66.7344H191.467",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.914 59.7617H135.588",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.76 66.7344H133.441",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.816 51.7256H200.444",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.943 87.1614H163.131C162.991 87.1614 162.886 87.0284 162.921 86.8954L164.167 82.1141C164.195 82.0231 164.279 81.9531 164.377 81.9531H192.189C192.329 81.9531 192.434 82.0861 192.399 82.2191L191.153 87.0004C191.125 87.0914 191.041 87.1614 190.943 87.1614Z",
    stroke: "#7094D8",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.375 87.1614H128.562C128.422 87.1614 128.317 87.0284 128.352 86.8954L129.599 82.1141C129.627 82.0231 129.711 81.9531 129.809 81.9531H157.621C157.761 81.9531 157.866 82.0861 157.831 82.2191L156.585 87.0004C156.564 87.0914 156.473 87.1614 156.375 87.1614Z",
    stroke: "#7094D8",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.387 32.8315H220.952",
    stroke: "#7094D8",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.45 174.469H102.264C100.682 174.469 99.5343 172.978 99.9333 171.452L113.955 117.584C114.235 116.52 115.194 115.778 116.286 115.778H266.472C268.054 115.778 269.202 117.269 268.803 118.795L254.781 172.663C254.501 173.727 253.542 174.469 252.45 174.469Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.859 127.301H175.117",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.834 151.417H171.099",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.814 142.31H193.072",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.516 135.337H137.196",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.373 142.31H135.054",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.426 127.301H202.054",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.553 162.737H164.74C164.6 162.737 164.495 162.604 164.53 162.471L165.776 157.689C165.804 157.598 165.888 157.528 165.986 157.528H193.799C193.939 157.528 194.044 157.661 194.009 157.794L192.763 162.576C192.742 162.667 192.651 162.737 192.553 162.737Z",
    stroke: "#84AEE5",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.98 162.737H130.168C130.028 162.737 129.923 162.604 129.958 162.471L131.204 157.689C131.232 157.598 131.316 157.528 131.414 157.528H159.226C159.366 157.528 159.471 157.661 159.436 157.794L158.19 162.576C158.162 162.667 158.078 162.737 157.98 162.737Z",
    stroke: "#84AEE5",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.441 155.799C240.013 153.902 234.231 152.516 232.635 150.619C231.816 149.646 231.816 147.847 232.012 146.314C232.579 145.95 233.055 145.586 233.335 145.25C233.818 144.55 234.357 143.57 234.896 142.492C235.057 142.653 235.281 142.779 235.561 142.772C236.317 142.751 239.208 138.816 238.466 137.899C238.039 137.381 237.353 137.829 236.842 138.312C237.605 136.562 238.144 135.218 238.144 135.218H238.116C238.186 134.994 238.256 134.777 238.312 134.546C239.46 129.947 236.66 126.216 232.061 126.216C227.462 126.216 222.799 129.947 221.651 134.546C221.595 134.77 221.553 134.994 221.511 135.218H221.483C221.483 135.218 221.35 136.562 221.245 138.312C220.972 137.829 220.51 137.374 219.824 137.899C218.627 138.809 219.551 142.744 220.3 142.772C220.58 142.779 220.86 142.653 221.105 142.492C221.105 143.57 221.161 144.55 221.294 145.25C221.434 145.663 221.833 146.118 222.358 146.559C221.784 148.036 220.916 149.702 219.684 150.619C217.136 152.516 210.668 153.902 208.295 155.799C206.16 157.507 204.255 162.499 203.898 163.479H242.008C242.141 162.492 242.722 157.507 241.441 155.799Z",
    fill: "#8DBCF8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.903 246.294H86.7175C85.1354 246.294 83.9874 244.802 84.3864 243.276L98.4081 189.409C98.6881 188.345 99.6472 187.603 100.739 187.603H250.925C252.507 187.603 253.655 189.094 253.256 190.62L239.234 244.487C238.954 245.551 237.995 246.294 236.903 246.294Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.316 199.125H159.581",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.297 223.242H155.555",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.273 214.134H177.538",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.979 207.162H121.652",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.836 214.134H119.51",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.885 199.125H186.513",
    stroke: "#A9C2FF",
    strokeWidth: 2.41512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.012 234.561H149.199C149.059 234.561 148.954 234.428 148.989 234.295L150.235 229.514C150.263 229.423 150.347 229.353 150.445 229.353H178.258C178.398 229.353 178.503 229.486 178.468 229.619L177.222 234.4C177.201 234.491 177.11 234.561 177.012 234.561Z",
    stroke: "#84AEE5",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.443 234.561H114.631C114.491 234.561 114.386 234.428 114.421 234.295L115.667 229.514C115.695 229.423 115.779 229.353 115.877 229.353H143.689C143.829 229.353 143.934 229.486 143.899 229.619L142.653 234.4C142.632 234.491 142.541 234.561 142.443 234.561Z",
    stroke: "#84AEE5",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.894 227.624C224.466 225.726 218.684 224.34 217.088 222.443C216.269 221.47 216.269 219.671 216.465 218.138C217.032 217.774 217.508 217.41 217.788 217.074C218.271 216.374 218.81 215.394 219.349 214.316C219.51 214.477 219.734 214.603 220.014 214.596C220.77 214.575 223.661 210.641 222.919 209.724C222.492 209.206 221.806 209.654 221.295 210.137C222.058 208.387 222.597 207.043 222.597 207.043H222.569C222.639 206.818 222.709 206.601 222.765 206.37C223.913 201.771 221.113 198.04 216.514 198.04C211.915 198.04 207.253 201.771 206.104 206.37C206.048 206.594 206.006 206.818 205.964 207.043H205.936C205.936 207.043 205.803 208.387 205.698 210.137C205.425 209.654 204.963 209.199 204.277 209.724C203.08 210.634 204.004 214.568 204.753 214.596C205.033 214.603 205.313 214.477 205.558 214.316C205.558 215.394 205.614 216.374 205.747 217.074C205.887 217.487 206.286 217.942 206.811 218.383C206.237 219.86 205.369 221.526 204.137 222.443C201.589 224.34 195.121 225.726 192.748 227.624C190.613 229.332 188.709 234.323 188.352 235.303H226.461C226.595 234.316 227.176 229.332 225.894 227.624Z",
    fill: "#8DBCF8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.877 246.56H233.674",
    stroke: "#7094D8",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.754 174.736H179.541",
    stroke: "#7094D8",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.145 174.736H209.692",
    stroke: "#7094D8",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.279 116.045H266.67C268.252 116.045 269.386 117.578 268.917 119.09L266.642 126.496",
    stroke: "#7094D8",
    strokeWidth: 0.805041,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6449 21.3297H87.8938C87.2007 21.3297 86.7807 20.7697 86.9557 20.0836L87.6417 17.3325C87.8168 16.6395 88.5098 16.0864 89.2028 16.0864H91.954C92.647 16.0864 93.067 16.6465 92.892 17.3325L92.206 20.0836C92.031 20.7767 91.3379 21.3297 90.6449 21.3297Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6332 29.3868H85.882C85.189 29.3868 84.769 28.8268 84.944 28.1408L85.63 25.3896C85.805 24.6966 86.4981 24.1436 87.1911 24.1436H89.9422C90.6353 24.1436 91.0553 24.7036 90.8803 25.3896L90.1943 28.1408C90.0193 28.8338 89.3262 29.3868 88.6332 29.3868Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3734 29.3868H94.6223C93.9292 29.3868 93.5092 28.8268 93.6842 28.1408L94.3703 25.3896C94.5453 24.6966 95.2383 24.1436 95.9313 24.1436H98.6825C99.3755 24.1436 99.7955 24.7036 99.6205 25.3896L98.9345 28.1408C98.7595 28.8338 98.0665 29.3868 97.3734 29.3868Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.12 29.3868H103.368C102.675 29.3868 102.255 28.8268 102.43 28.1408L103.116 25.3896C103.291 24.6966 103.984 24.1436 104.677 24.1436H107.429C108.122 24.1436 108.542 24.7036 108.367 25.3896L107.681 28.1408C107.506 28.8338 106.813 29.3868 106.12 29.3868Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5804 37.6339H83.8293C83.1363 37.6339 82.7162 37.0739 82.8913 36.3878L83.5773 33.6367C83.7523 32.9437 84.4453 32.3906 85.1384 32.3906H87.8895C88.5825 32.3906 89.0026 32.9507 88.8276 33.6367L88.1415 36.3878C87.9665 37.0809 87.2735 37.6339 86.5804 37.6339Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3812 46.44H81.6301C80.9371 46.44 80.517 45.88 80.692 45.194L81.3781 42.4428C81.5531 41.7498 82.2461 41.1968 82.9392 41.1968H85.6903C86.3833 41.1968 86.8034 41.7568 86.6283 42.4428L85.9423 45.194C85.7673 45.887 85.0743 46.44 84.3812 46.44Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3246 37.6339H92.5735C91.8804 37.6339 91.4604 37.0739 91.6354 36.3878L92.3214 33.6367C92.4964 32.9437 93.1895 32.3906 93.8825 32.3906H96.6337C97.3267 32.3906 97.7467 32.9507 97.5717 33.6367L96.8857 36.3878C96.7107 37.0809 96.0176 37.6339 95.3246 37.6339Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4926 52.9996H88.7414C88.0484 52.9996 87.6284 52.4396 87.8034 51.7535L88.4894 49.0024C88.6644 48.3094 89.3574 47.7563 90.0505 47.7563H92.8016C93.4947 47.7563 93.9147 48.3164 93.7397 49.0024L93.0536 51.7535C92.8786 52.4466 92.1856 52.9996 91.4926 52.9996Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.726 5.32765C134.726 5.32765 134.698 5.32765 134.684 5.32765C134.642 5.32765 134.6 5.32065 134.558 5.31365C134.278 5.29965 133.991 5.28564 133.697 5.28564C125.549 5.28564 117.303 11.817 115.132 19.9304L115.034 20.3154C115.027 20.3574 115.02 20.3994 115.006 20.4344L114.943 20.6794H114.95C113.165 28.9048 118.437 35.4502 126.886 35.1072C134.586 34.7921 142.357 28.6458 144.674 21.0224C147.18 12.755 142.616 5.86667 134.726 5.31365V5.32765ZM140.348 20.7564C138.724 26.1747 133.165 30.5499 127.705 30.7179C121.832 30.9069 118.164 26.3427 119.375 20.6094L119.543 19.9304C121.104 14.2461 126.893 9.68887 132.612 9.68887C132.906 9.68887 133.2 9.70287 133.48 9.73087C138.941 10.1929 142.084 15.0021 140.355 20.7564H140.348Z",
    fill: "#EBEDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.919 7.86889C133.667 8.88394 134.136 9.75898 135.06 10.004C139.512 11.1801 141.892 15.5903 140.338 20.7565C138.714 26.1748 133.155 30.55 127.695 30.718C122.333 30.8861 118.812 27.1129 119.155 22.0936C119.225 21.0576 118.49 20.3155 117.44 20.3155C116.075 20.3155 114.717 21.5476 114.626 22.8846C114.143 30.039 119.204 35.4223 126.883 35.1073C134.584 34.7922 142.354 28.6459 144.671 21.0226C146.904 13.6652 143.537 7.39286 137.202 5.71278C135.893 5.36276 134.283 6.41281 133.919 7.84789V7.86889Z",
    fill: "#A5C5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.838 3.82284C171.838 3.82284 171.81 3.82284 171.796 3.82284C171.747 3.82284 171.691 3.82284 171.642 3.81584C171.369 3.80184 171.089 3.78784 170.809 3.78784C162.569 3.78784 154.218 10.4662 152.167 18.7126C150.108 26.952 155.128 33.6374 163.367 33.6374C163.647 33.6374 163.927 33.6234 164.214 33.6094C164.27 33.6094 164.319 33.6094 164.375 33.6024C164.389 33.6024 164.403 33.6024 164.417 33.6024C172.265 33.0703 179.958 26.679 181.981 18.8456C181.995 18.8036 182.009 18.7616 182.016 18.7126C183.983 10.8232 179.468 4.36187 171.838 3.82984V3.82284ZM165.208 29.1991C165.208 29.1991 165.18 29.1991 165.166 29.1991C164.991 29.2131 164.816 29.2201 164.648 29.2201C164.585 29.2201 164.529 29.2201 164.466 29.2201C158.656 29.2201 155.121 24.5089 156.57 18.6986C158.019 12.8883 163.899 8.17706 169.709 8.17706C169.772 8.17706 169.828 8.17706 169.884 8.17706C170.059 8.17706 170.227 8.18406 170.395 8.19807C170.409 8.19807 170.423 8.19807 170.437 8.19807C175.807 8.57608 178.985 13.1263 177.599 18.6846C177.585 18.7266 177.578 18.7686 177.564 18.8176C176.122 24.3199 170.718 28.8071 165.201 29.1781L165.208 29.1991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.935 20.673C175.087 24.8942 170.936 28.2193 166.525 29.0314C165.419 29.2344 164.425 30.1304 164.159 31.2015C163.816 32.5876 164.824 33.6236 166.245 33.3646C172.539 32.2235 178.454 27.4773 181.079 21.457C181.674 20.0989 180.953 18.8389 179.567 18.8389C178.489 18.8389 177.404 19.6159 176.935 20.673Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.252 56.3391H104.439C104.299 56.3391 104.194 56.2061 104.229 56.0731L105.476 51.2919C105.504 51.2009 105.588 51.1309 105.686 51.1309H133.498C133.638 51.1309 133.743 51.2639 133.708 51.3969L132.462 56.1781C132.434 56.2691 132.35 56.3391 132.252 56.3391Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.393 70.3467C264.692 77.165 257.783 82.6953 250.964 82.6953C244.146 82.6953 239.995 77.165 241.696 70.3467C243.397 63.5283 250.306 57.998 257.124 57.998C263.943 57.998 268.094 63.5283 266.393 70.3467Z",
    fill: "#73A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.294 83.6121C271.832 85.4812 269.935 86.9933 268.073 86.9933C266.211 86.9933 265.07 85.4812 265.539 83.6121C266.001 81.743 267.898 80.231 269.76 80.231C271.622 80.231 272.763 81.743 272.294 83.6121Z",
    fill: "#73A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.861 76.6262C250.476 76.6262 250.119 76.4792 249.895 76.1781L246.703 71.9289C246.255 71.3339 246.5 70.3748 247.235 69.7798C247.977 69.1848 248.936 69.1848 249.384 69.7798L251.771 72.958L260.291 66.1396C261.033 65.5446 261.992 65.5446 262.44 66.1396C262.888 66.7347 262.643 67.6937 261.908 68.2887L252.044 76.1851C251.673 76.4792 251.246 76.6332 250.861 76.6332V76.6262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3609 285.691C92.4463 285.691 116.025 283.71 116.025 281.267C116.025 278.824 92.4463 276.843 63.3609 276.843C34.2756 276.843 10.6973 278.824 10.6973 281.267C10.6973 283.71 34.2756 285.691 63.3609 285.691Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1551 267.042C42.1551 267.042 43.2751 264.648 47.4193 265.285C51.5635 265.922 52.0466 266.72 52.5296 268.799C53.0056 270.871 54.4477 273.111 55.3997 273.587C56.3588 274.063 59.866 276.457 62.7431 276.94C65.6132 277.416 65.9353 279.173 65.2982 279.971C64.6612 280.769 53.8036 281.406 51.4095 281.091C51.4095 281.091 43.2681 280.93 41.357 280.293C39.4389 279.656 41.9941 267.847 42.1551 267.049V267.042Z",
    fill: "#2D2737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.549 210.934C37.549 210.934 36.338 204.326 43.3173 202.107C50.2967 199.888 51.6197 203.115 53.7338 209.142C55.8479 215.169 51.9207 266.671 51.9207 266.671C51.9207 266.671 43.8843 268.043 41.8192 266.825C41.8192 266.825 35.6939 233.3 36.1209 224.102C36.548 214.903 37.556 210.934 37.556 210.934H37.549Z",
    fill: "#676F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.959 264.802C40.959 264.802 50.0594 264.004 52.9296 263.528L52.7686 267.679C52.7686 267.679 45.5862 268.953 41.12 268.316L40.959 264.802Z",
    fill: "#51598D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7245 81.8965C38.7245 81.8965 32.9772 82.2185 29.47 95.3022C25.9558 108.393 23.7227 124.347 25.0038 128.498C26.2778 132.649 40.0055 143.822 45.1158 143.822C50.2261 143.822 50.5411 139.992 49.582 136.8C48.623 133.608 38.7315 124.991 38.7315 124.991C38.7315 124.991 46.7119 99.4534 46.3899 92.754C46.0678 86.0547 42.2387 81.9035 38.7315 81.9035L38.7245 81.8965Z",
    fill: "#0956A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.669 77.9975L109.717 78.0955L111.852 73.8673C111.852 73.8673 117.284 73.5243 118.152 75.8204L115.66 81.3437L110.669 78.0045V77.9975Z",
    fill: "#FF8D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.717 65.9777C113.717 65.9777 113.507 61.6584 115.04 61.0424C116.58 60.4264 118.302 61.6234 118.302 61.6234C118.302 61.6234 120.787 61.3714 121.585 62.4285C122.383 63.4855 122.313 65.0956 122.313 65.0956C122.313 65.0956 123.713 65.4106 124.084 66.7407C124.448 68.0778 123.797 70.6539 123.797 70.6539C123.797 70.6539 122.173 72.649 120.29 72.152C118.414 71.655 113.717 65.9637 113.717 65.9637V65.9777Z",
    fill: "#FF7759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.874 69.4705C110.874 69.4705 110.3 63.8142 110.909 63.0652C111.518 62.3162 117.748 53.6987 117.748 53.6987C117.748 53.6987 119.043 55.1688 118.294 56.8419C117.552 58.515 114.619 63.6042 114.619 63.6042L114.605 67.9515C114.605 67.9515 112.687 69.2885 110.874 69.4775V69.4705Z",
    fill: "#FF7759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.338 73.9925C111.338 73.9925 109.847 64.9131 110.862 63.66C111.877 62.414 116.861 63.142 117.806 63.499C118.758 63.856 121.39 67.2512 121.754 68.5813C122.118 69.9113 119.64 74.7416 118.149 75.8056C116.658 76.8697 112.199 75.7286 111.338 73.9856V73.9925Z",
    fill: "#FF8D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.83 79.9856L109.748 76.4714C109.748 76.4714 114.214 75.6734 116.455 79.1875C117.092 80.4616 116.777 80.4616 116.777 80.4616L115.341 83.3318L107.837 79.9786L107.83 79.9856Z",
    fill: "#DEE0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3626 41.5607C62.3626 41.5607 67.0878 42.7717 69.762 50.0171C72.4361 57.2694 70.651 72.6772 68.8729 74.4903C67.0949 76.3034 61.6696 75.6104 54.1582 73.1323C46.2198 70.5141 43.5387 62.2607 42.1176 56.8214C39.4014 46.3979 48.4669 35.6734 62.3626 41.5677V41.5607Z",
    fill: "#FF8D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4308 81.5818L49.26 67.8541C49.26 67.8541 56.9184 65.621 61.7067 70.7242L63.3027 72.9574V81.8968C63.3027 81.8968 55.3223 83.4929 45.4238 81.5748L45.4308 81.5818Z",
    fill: "#FF8D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7327 155.477C34.7327 155.477 31.8625 172.236 34.7327 191.389C37.6028 210.542 43.3501 212.46 48.6214 212.46C53.8926 212.46 55.3277 197.136 56.2797 190.437C57.2388 183.731 61.068 160.749 53.8856 155.484C46.7033 150.22 38.5618 149.737 34.7327 155.484V155.477Z",
    fill: "#676F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8455 177.983C54.8455 177.983 49.0982 162.66 59.1577 155.96C69.2102 149.254 76.8756 150.213 79.2697 161.225C81.6638 172.236 82.1398 210.066 78.7937 217.724C75.4405 225.383 63.4699 213.412 54.8525 177.983H54.8455Z",
    fill: "#676F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5793 42.2115C71.5793 42.2115 73.8474 45.1587 72.4823 48.5538C71.1243 51.956 66.14 53.3141 66.14 53.3141C66.14 53.3141 67.7291 55.5822 66.14 58.7534L65.006 60.5664C65.006 60.5664 66.595 64.1926 66.14 65.0957C65.685 65.9987 64.1029 65.7747 64.1029 65.7747C64.1029 65.7747 62.2898 60.7905 61.6108 61.2455C60.9317 61.7005 59.1187 63.9616 59.1187 66.0057C59.1187 68.0498 59.7977 69.6319 59.3427 70.99C58.8876 72.348 51.8663 72.348 48.9191 71.893C45.972 71.438 41.4428 62.3795 40.3087 58.2983C40.3087 58.2983 38.7196 52.635 40.9877 47.8748C40.9877 47.8748 40.5327 43.7936 44.3899 39.7194C48.2401 35.6382 60.4767 37.0033 62.5138 38.5853C62.5138 38.5853 62.2898 36.3172 64.5509 36.7722C66.819 37.2273 70.2142 39.2644 71.5723 42.2115H71.5793Z",
    fill: "#252549"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7796 62.8344C64.7796 62.8344 64.1005 59.8873 61.6084 61.2453C59.1163 62.6034 62.0634 69.6318 64.1005 69.1768C66.1376 68.7217 65.2346 63.9685 64.7796 62.8344Z",
    fill: "#FF7759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4023 81.5047C43.4023 81.5047 44.4734 77.7455 45.4325 77.4305C46.3915 77.1085 58.2011 75.8344 64.5854 79.6636C67.4556 81.8968 67.1405 83.4928 67.1405 83.4928C67.1405 83.4928 48.0856 79.8386 43.4093 81.5047H43.4023Z",
    fill: "#DEE0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9582 80.6224C40.9582 80.6224 60.7482 79.3483 74.7909 85.4106C81.1753 88.6028 95.778 103.045 95.778 103.045L107.273 79.1033C107.273 79.1033 113.734 76.7862 116.289 82.8555C116.289 82.8555 109.03 111.102 102.96 120.041C99.1312 123.234 80.8533 112.859 80.8533 112.859C80.8533 112.859 83.7234 149.884 82.7714 166.489C81.4973 169.681 56.597 171.277 52.1308 170.955C47.6646 170.633 32.0188 165.53 31.7038 164.571C31.3817 163.612 33.9369 125.306 33.2998 120.839C32.6628 116.373 30.7447 94.3431 31.3817 91.1509C32.0188 87.9588 34.8959 81.8964 40.9582 80.6154V80.6224Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.029 267.995C62.029 267.995 63.149 265.601 67.2933 266.238C71.4445 266.875 71.9205 267.673 72.4035 269.752C72.8865 271.831 74.3216 274.064 75.2737 274.54C76.2257 275.016 79.7399 277.41 82.617 277.893C85.4872 278.369 85.8092 280.126 85.1722 280.924C84.5351 281.722 73.6776 282.359 71.2835 282.044C71.2835 282.044 63.142 281.883 61.231 281.246C59.3199 280.609 61.868 268.8 62.029 268.002V267.995Z",
    fill: "#3E3343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9377 211.978C63.9377 211.978 63.4617 205.271 70.6441 203.836C77.8265 202.401 78.7855 205.754 80.2206 211.978C81.6556 218.201 72.0792 268.953 72.0792 268.953C72.0792 268.953 63.9378 269.429 62.0267 267.994C62.0267 267.994 59.6325 234.001 61.0676 224.9C62.5027 215.8 63.9377 211.971 63.9377 211.971V211.978Z",
    fill: "#676F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3934 268.793C61.3934 268.793 67.6167 270.55 72.888 269.591L73.364 265.923L61.2324 265.125L61.3934 268.793Z",
    fill: "#51598D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9297 174.393C52.9297 174.393 59.636 195.94 64.6623 206.475",
    stroke: "#2A2E59",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5762 210.78C66.5762 210.78 70.6434 208.386 74.7176 210.78",
    stroke: "#2A2E59",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8594 213.413C65.8594 213.413 69.2125 211.494 74.9598 215.569",
    stroke: "#2A2E59",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7207 207.903C40.7207 207.903 43.3528 205.509 49.3381 208.141",
    stroke: "#2A2E59",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6406 210.297C42.6406 210.297 46.4698 208.379 50.061 211.256",
    stroke: "#2A2E59",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4956 214.133L50.0605 262.967",
    stroke: "#2A2E59",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2852 173.195C71.2852 173.195 76.7104 176.387 78.9435 171.277",
    stroke: "#2A2E59",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.709 173.832C76.709 173.832 79.2641 193.622 78.6271 206.713",
    stroke: "#2A2E59",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3809 99.4531L33.936 126.909",
    stroke: "#524B81",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1973 109.03C75.1973 109.03 94.1122 122.673 102.968 120.041",
    stroke: "#524B81",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6973 105.677C97.6973 105.677 101.526 107.833 101.288 112.859",
    stroke: "#524B81",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7422 103.765C96.7422 103.765 100.809 102.568 103.204 106.636",
    stroke: "#524B81",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4758 87.2446C74.4758 87.2446 64.4233 92.5089 71.1227 104.725",
    stroke: "#524B81",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2266 71.3262C60.2266 71.3262 61.8996 75.6384 67.5279 74.9174",
    stroke: "#E66657",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.418 62.4704L116.294 60.7974C116.294 60.7974 117.61 60.7974 118.31 61.6304",
    stroke: "#E66657",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.652 62.7435C116.652 62.6245 119.326 61.1895 119.326 61.1895C119.326 61.1895 121.763 61.7845 122.12 63.0655C122.477 64.3396 122.197 65.0186 122.197 65.0186",
    stroke: "#E66657",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.803 65.0604C119.922 65.0184 123.191 65.2214 123.191 65.2214C123.191 65.2214 124.388 66.0195 124.346 67.5735C124.304 69.1276 123.793 70.6677 123.793 70.6677C123.793 70.6677 122.631 72.3268 120.636 72.2848",
    stroke: "#E66657",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.681 68.4136C121.681 68.4136 122.08 69.0506 121.562 70.2057C121.043 71.3607 120.413 74.3919 118.152 75.8129",
    stroke: "#E66657",
    strokeWidth: 0.721036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7698 47.6233C49.1005 45.3482 43.1152 48.0993 43.1152 48.0993C43.1152 48.0993 43.8363 44.9841 47.1824 43.9131",
    stroke: "#A03A45",
    strokeWidth: 0.959049,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3516 50.0171C43.3516 50.0171 44.5486 49.8981 46.1027 52.2922",
    stroke: "#A03A45",
    strokeWidth: 0.959049,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9395 39.2861C63.9395 39.2861 69.8478 40.2452 70.0018 46.1465",
    stroke: "#A03A45",
    strokeWidth: 0.959049,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2418_9477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 385.096,
    height: 285.684,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalDetail);
export default __webpack_public_path__ + "static/media/personalDetail.92d065ae5377624e193d50d0c480dfe4.svg";
export { ForwardRef as ReactComponent };